export type Language = "en" | "es" | "hi" | "sr";

export interface Translations {
  questionTitle: string;
  questionSubtitle: string;
  questionPlaceholder: string;
  drawCard: string;
  questionWarning: string;
  aboutPrivacy: string;
  reversed: string;
  drawClarifying: string;
  drawAgain: string;
  clarifyingCard: string;
  drawAnotherClarifying: string;
  reversedCards: string;
  aiReading: string;
  moreAboutUs: string;
  language: string;
  soundOn: string;
  soundOff: string;
  symbolism: string;
  readingError: string;
  darkMode: string;
  lightMode: string;
  installApp: string;
  readingType: string;
  singleCard: string;
  pastPresentFuture: string;
  past: string;
  present: string;
  future: string;
  drawPastCard: string;
  drawPresentCard: string;
  drawFutureCard: string;
  focus: string;
  drawFocusCard: string;
  relationshipSpread: string;
  youWant: string;
  partnerWants: string;
  relationshipHeading: string;
  threeCardSpread: string;
  youPositionPotential: string;
  youCard: string;
  yourPosition: string;
  yourPotential: string;
  unconsciousConsciousSuperconscious: string;
  unconscious: string;
  conscious: string;
  superconscious: string;
  embraceAcceptLetGo: string;
  embrace: string;
  accept: string;
  letGo: string;
  situationObstacleLesson: string;
  theSituation: string;
  theObstacle: string;
  theLesson: string;
  hintSignIn: string;
  hintMenu: string;
  buyMeACoffee: string;
  yesOrNo: string;
}

export const translations: Record<Language, Translations> = {
  en: {
    questionTitle: "What does your heart seek?",
    questionSubtitle: "Focus your intention, then draw a card",
    questionPlaceholder:
      "Ask your question… \n \n Add as much context as you need to share",
    drawCard: "Start Reading",
    questionWarning:
      "Share your question or intention — a little context helps the reading find its way.",
    aboutPrivacy: "About & Privacy",
    reversed: "Reversed",
    drawClarifying: "Draw Clarifying Card",
    drawAgain: "Ask a New Question",
    clarifyingCard: "Clarifying Card",
    drawAnotherClarifying: "Draw Another Clarifying Card",
    reversedCards: "Reversed Cards",
    aiReading: "AI Reading",
    moreAboutUs: "More About Us",
    language: "Language",
    soundOn: "♪ Sound On",
    soundOff: "♪ Sound Off",
    symbolism: "Symbolism",
    readingError:
      "The cards cannot be read at this time. Please try again shortly.",
    darkMode: "🌙 Dark mode",
    lightMode: "☀️ Light mode",
    installApp: "Install App",
    readingType: "Reading type",
    singleCard: "Single Card",
    pastPresentFuture: "Past, Present, Future",
    past: "Past",
    present: "Present",
    future: "Future",
    drawPastCard: "Draw your Past card",
    drawPresentCard: "Draw your Present card",
    drawFutureCard: "Draw your Future card",
    focus: "Focus",
    drawFocusCard: "Draw a Focus Card",
    relationshipSpread: "Your Wants, Partner Wants, Relationship Heading",
    youWant: "You Want",
    partnerWants: "Partner Wants",
    relationshipHeading: "Heading Towards",
    threeCardSpread: "3 Card Spread",
    youPositionPotential: "You, Your Position, Your Potential",
    youCard: "You",
    yourPosition: "Your Position",
    yourPotential: "Your Potential",
    unconsciousConsciousSuperconscious: "Unconscious, Conscious, Superconscious",
    unconscious: "Unconscious",
    conscious: "Conscious",
    superconscious: "Superconscious",
    embraceAcceptLetGo: "Embrace, Accept, Let Go",
    embrace: "Embrace",
    accept: "Accept",
    letGo: "Let Go",
    situationObstacleLesson: "Situation, Obstacle, Lesson",
    theSituation: "The Situation",
    theObstacle: "The Obstacle",
    theLesson: "The Lesson",
    hintSignIn: "Sign in to unlock spread readings & more",
    hintMenu: "Customize your reading here",
    buyMeACoffee: "Buy Me a Coffee",
    yesOrNo: "Yes or No",
  },
  es: {
    questionTitle: "¿Qué busca tu corazón?",
    questionSubtitle: "Enfoca tu intención y luego saca una carta",
    questionPlaceholder: "Haz tu pregunta… \n \n Añade todo el contexto que necesites compartir",
    drawCard: "Comenzar Lectura",
    questionWarning:
      "Comparte tu pregunta o intención — un poco de contexto ayuda a la lectura a encontrar su camino.",
    aboutPrivacy: "Sobre Nosotros y Privacidad",
    reversed: "Invertida",
    drawClarifying: "Sacar Carta Aclaratoria",
    drawAgain: "Hacer una Nueva Pregunta",
    clarifyingCard: "Carta Aclaratoria",
    drawAnotherClarifying: "Sacar Otra Carta Aclaratoria",
    reversedCards: "Cartas Invertidas",
    aiReading: "Lectura de IA",
    moreAboutUs: "Más Sobre Nosotros",
    language: "Idioma",
    soundOn: "♪ Sonido Activado",
    soundOff: "♪ Sonido Desactivado",
    symbolism: "Simbolismo",
    readingError:
      "Las cartas no pueden leerse en este momento. Por favor, inténtalo de nuevo en breve.",
    darkMode: "🌙 Modo oscuro",
    lightMode: "☀️ Modo claro",
    installApp: "Instalar App",
    readingType: "Tipo de lectura",
    singleCard: "Carta única",
    pastPresentFuture: "Pasado, Presente, Futuro",
    past: "Pasado",
    present: "Presente",
    future: "Futuro",
    drawPastCard: "Saca tu carta del Pasado",
    drawPresentCard: "Saca tu carta del Presente",
    drawFutureCard: "Saca tu carta del Futuro",
    focus: "Enfoque",
    drawFocusCard: "Sacar Carta de Enfoque",
    relationshipSpread: "Lo Que Tú Quieres, Lo Que Tu Pareja Quiere, Hacia Dónde Va la Relación",
    youWant: "Lo Que Tú Quieres",
    partnerWants: "Lo Que Tu Pareja Quiere",
    relationshipHeading: "Hacia Dónde Va",
    threeCardSpread: "Tirada de 3 Cartas",
    youPositionPotential: "Tú, Tu Posición, Tu Potencial",
    youCard: "Tú",
    yourPosition: "Tu Posición",
    yourPotential: "Tu Potencial",
    unconsciousConsciousSuperconscious: "Inconsciente, Consciente, Superconsciente",
    unconscious: "Inconsciente",
    conscious: "Consciente",
    superconscious: "Superconsciente",
    embraceAcceptLetGo: "Abrazar, Aceptar, Soltar",
    embrace: "Abrazar",
    accept: "Aceptar",
    letGo: "Soltar",
    situationObstacleLesson: "Situación, Obstáculo, Lección",
    theSituation: "La Situación",
    theObstacle: "El Obstáculo",
    theLesson: "La Lección",
    hintSignIn: "Inicia sesión para spreads y más",
    hintMenu: "Personaliza tu lectura aquí",
    buyMeACoffee: "Invítame un café",
    yesOrNo: "Sí o No",
  },
  hi: {
    questionTitle: "आपका हृदय क्या खोजता है?",
    questionSubtitle: "अपनी भावना केंद्रित करें, फिर एक कार्ड खींचें",
    questionPlaceholder: "अपना प्रश्न पूछें… \n \n जितना संदर्भ साझा करना हो, जोड़ें",
    drawCard: "पढ़ना शुरू करें",
    questionWarning:
      "अपना प्रश्न या इरादा साझा करें — थोड़ा संदर्भ पठन को मार्ग दिखाता है।",
    aboutPrivacy: "हमारे बारे में और गोपनीयता",
    reversed: "उलटा",
    drawClarifying: "स्पष्टीकरण कार्ड खींचें",
    drawAgain: "नया प्रश्न पूछें",
    clarifyingCard: "स्पष्टीकरण कार्ड",
    drawAnotherClarifying: "एक और स्पष्टीकरण कार्ड खींचें",
    reversedCards: "उलटे कार्ड",
    aiReading: "AI पठन",
    moreAboutUs: "हमारे बारे में अधिक जानें",
    language: "भाषा",
    soundOn: "♪ ध्वनि चालू",
    soundOff: "♪ ध्वनि बंद",
    symbolism: "प्रतीकवाद",
    readingError:
      "इस समय कार्ड नहीं पढ़े जा सकते। कृपया थोड़ी देर बाद पुनः प्रयास करें।",
    darkMode: "🌙 डार्क मोड",
    lightMode: "☀️ लाइट मोड",
    installApp: "ऐप इंस्टॉल करें",
    readingType: "पठन प्रकार",
    singleCard: "एकल कार्ड",
    pastPresentFuture: "भूत, वर्तमान, भविष्य",
    past: "भूत",
    present: "वर्तमान",
    future: "भविष्य",
    drawPastCard: "अपना भूत कार्ड खींचें",
    drawPresentCard: "अपना वर्तमान कार्ड खींचें",
    drawFutureCard: "अपना भविष्य कार्ड खींचें",
    focus: "फोकस",
    drawFocusCard: "फोकस कार्ड खींचें",
    relationshipSpread: "आप क्या चाहते हैं, साथी क्या चाहता है, रिश्ता किस ओर जा रहा है",
    youWant: "आप क्या चाहते हैं",
    partnerWants: "आपका साथी क्या चाहता है",
    relationshipHeading: "रिश्ता किस ओर जा रहा है",
    threeCardSpread: "3 कार्ड स्प्रेड",
    youPositionPotential: "आप, आपकी स्थिति, आपकी क्षमता",
    youCard: "आप",
    yourPosition: "आपकी स्थिति",
    yourPotential: "आपकी क्षमता",
    unconsciousConsciousSuperconscious: "अचेतन, चेतन, अतिचेतन",
    unconscious: "अचेतन",
    conscious: "चेतन",
    superconscious: "अतिचेतन",
    embraceAcceptLetGo: "अपनाएं, स्वीकार करें, जाने दें",
    embrace: "अपनाएं",
    accept: "स्वीकार करें",
    letGo: "जाने दें",
    situationObstacleLesson: "स्थिति, बाधा, सीख",
    theSituation: "स्थिति",
    theObstacle: "बाधा",
    theLesson: "सीख",
    hintSignIn: "स्प्रेड पढ़ने के लिए साइन इन करें",
    hintMenu: "यहाँ पठन अनुकूलित करें",
    buyMeACoffee: "कॉफ़ी खरीदें",
    yesOrNo: "हाँ या नहीं",
  },
  sr: {
    questionTitle: "Šta traži vaše srce?",
    questionSubtitle: "Usmerite svoju nameru, zatim izvucite kartu",
    questionPlaceholder: "Postavite svoje pitanje… \n \n Dodajte onoliko konteksta koliko trebate podeliti",
    drawCard: "Započni Čitanje",
    questionWarning:
      "Podelite svoje pitanje ili nameru — malo konteksta pomaže čitanju da pronađe put.",
    aboutPrivacy: "O nama i privatnost",
    reversed: "Obrnuta",
    drawClarifying: "Izvuci Pojašnjavajuću Kartu",
    drawAgain: "Postavi Novo Pitanje",
    clarifyingCard: "Pojašnjavajuća Karta",
    drawAnotherClarifying: "Izvuci Još Jednu Pojašnjavajuću Kartu",
    reversedCards: "Obrnute Karte",
    aiReading: "AI Čitanje",
    moreAboutUs: "Više o nama",
    language: "Jezik",
    soundOn: "♪ Zvuk Uključen",
    soundOff: "♪ Zvuk Isključen",
    symbolism: "Simbolizam",
    readingError:
      "Karte trenutno ne mogu biti pročitane. Molimo pokušajte ponovo uskoro.",
    darkMode: "🌙 Tamni režim",
    lightMode: "☀️ Svetli režim",
    installApp: "Instaliraj App",
    readingType: "Vrsta čitanja",
    singleCard: "Jedna karta",
    pastPresentFuture: "Prošlost, Sadašnjost, Budućnost",
    past: "Prošlost",
    present: "Sadašnjost",
    future: "Budućnost",
    drawPastCard: "Izvuci svoju kartu Prošlosti",
    drawPresentCard: "Izvuci svoju kartu Sadašnjosti",
    drawFutureCard: "Izvuci svoju kartu Budućnosti",
    focus: "Fokus",
    drawFocusCard: "Izvuci Kartu Fokusa",
    relationshipSpread: "Šta Ti Želiš, Šta Partner Želi, Ka Čemu Veza Vodi",
    youWant: "Šta Ti Želiš",
    partnerWants: "Šta Partner Želi",
    relationshipHeading: "Ka Čemu Vodi",
    threeCardSpread: "Tarot od 3 Karte",
    youPositionPotential: "Ti, Tvoja Pozicija, Tvoj Potencijal",
    youCard: "Ti",
    yourPosition: "Tvoja Pozicija",
    yourPotential: "Tvoj Potencijal",
    unconsciousConsciousSuperconscious: "Nesvesno, Svesno, Nadsvesno",
    unconscious: "Nesvesno",
    conscious: "Svesno",
    superconscious: "Nadsvesno",
    embraceAcceptLetGo: "Zagrli, Prihvati, Pusti",
    embrace: "Zagrli",
    accept: "Prihvati",
    letGo: "Pusti",
    situationObstacleLesson: "Situacija, Prepreka, Lekcija",
    theSituation: "Situacija",
    theObstacle: "Prepreka",
    theLesson: "Lekcija",
    hintSignIn: "Prijavite se za više funkcija",
    hintMenu: "Prilagodite čitanje ovde",
    buyMeACoffee: "Počasti me kafom",
    yesOrNo: "Da ili Ne",
  },
};

export const languageNames: Record<Language, string> = {
  en: "English",
  es: "Español",
  hi: "हिन्दी",
  sr: "Srpski",
};

// Names passed to the AI so it responds in the right language
export const languageAPINames: Record<Language, string> = {
  en: "English",
  es: "Spanish",
  hi: "Hindi",
  sr: "Serbian",
};
